import { useEffect, useRef, useState } from 'react';

const profile = 'https://www.instagram.com/socialpawsapp/';
export default function InstagramPost() {
  const widget = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const target = widget.current;
    if (!target) return;
    const checkReady = () => {
      const renderedPosts = target.querySelectorAll('a[href*="instagram.com/p/"], a[href*="instagram.com/reel/"], .eapps-instagram-feed-posts-item');
      if ([...renderedPosts].some(post => post.getBoundingClientRect().height > 0)) setLoaded(true);
    };
    const observer = new MutationObserver(checkReady);
    const resizeObserver = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(checkReady);
    resizeObserver?.observe(target);
    target.addEventListener('load', checkReady, true);
    observer.observe(target, { childList: true, subtree: true, attributes: true });
    const script = document.createElement('script');
    script.src = 'https://elfsightcdn.com/platform.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      observer.disconnect();
      resizeObserver?.disconnect();
      target.removeEventListener('load', checkReady, true);
      script.remove();
    };
  }, []);

  return <section className="instagram-feed" aria-label="Social Paws Instagram feed">
    <div className={loaded ? 'instagram-widget-shell' : 'instagram-widget-shell instagram-widget-shell--pending'}>
      <div ref={widget} className="elfsight-app-93bb8c8e-98fc-473c-bdaa-b3257edb2b8c" data-elfsight-app-lazy/>
    </div>
    {!loaded && <div className="instagram-fallback"><a href={profile} target="_blank" rel="noopener noreferrer">See our latest photos on Instagram ↗</a></div>}
  </section>;
}
